import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "confirm-dialog-icon" }
const _hoisted_2 = { class: "confirm-dialog-title" }
const _hoisted_3 = { class: "confirm-dialog-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "520",
    persistent: "",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "confirm-dialog-card",
        rounded: "xl"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "pa-6 pa-md-7" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_icon, {
                  icon: _ctx.icon,
                  size: "30",
                  color: _ctx.color
                }, null, 8, ["icon", "color"])
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "confirm-dialog-eyebrow" }, "Megerősítés", -1)),
              _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.text), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "justify-end px-6 pb-6 pt-0 ga-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                color: "secondary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.cancelText), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: _ctx.color,
                variant: "flat",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.confirmText), 1)
                ]),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}